export default (state, action) => {
  switch (action.type) {
    case "UPDATE_COOKIES":
      return {
        ...state,
        cookies: action.payload,
      };
    case "SHOW_COOKIE_BANNER":
      return {
        ...state,
        cookiesSetted: action.payload,
      };
    default:
      return state;
  }
};
